module.exports = __webpack_public_path__ + "img/Stella cadente.757723bc.svg";